import { PageSectionProps } from "@components/page-section/page-section";
import { AccountCookiesPreferences } from "@pages/account-settings/sections/account-cookies-preferences";
import { runtimeConfig } from "@src/runtime-config";

/** Content for the privacy tab of account settings page */
export function accountSettingsPrivacyTab(): PageSectionProps[] {
  return [
    {
      title: "Cookie preferences",
      subtitle:
        "We use cookies & similar technologies to improve and personalize your user experience, " +
        "deliver adverts to your interests on third party platforms and analyze our web traffic.",
      // Cookies are not stored in EU therefore we don't show the cookie manager there
      isHidden: !runtimeConfig.urls.cookieManagerUrl,
      items: [
        {
          label: "Cookie policy",
          content: <AccountCookiesPreferences />,
          shouldAlignToEnd: true,
          shouldAddRightPadding: true,
          shouldHideTopBorder: true,
          shouldHidePaddingY: true,
        },
      ],
    },
  ];
}
